import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Tributo } from '../../components'
import * as tributoActionCreators from '../../redux/modules/tributo'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class TributoContainer extends Component {

  static propTypes = {
    history: PropTypes.object.isRequired,
    multipleTributo: PropTypes.object.isRequired,
    fetchMultipleTributo: PropTypes.func.isRequired,
    destroyTributo: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleTributo()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/tributos/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/tributos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyTributo(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('tributo', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('tributo', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleTributo.toList().toJSON(),
      'tributo',
      ['id', 'nome', 'descricao'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Tributo
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleTributo={this.props.multipleTributo}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({ tributo, status, sort, filter }) {
  const sortColumn = sort.getIn(['tributo', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['tributo', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['tributo', 'filterText']) || ''

  let map = filterMap(tributo, ['nome', 'descricao'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleTributo: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['tributo', 'error']),
    isLoading: status.getIn(['tributo', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...tributoActionCreators,
    ...flashMessageAcionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TributoContainer)
